/**
 * A button that renders a `rightIcon` when `active`.
 * Might add some additional styles here.
 */
import React from 'react';
import Button, { ButtonProps } from './Button';

function SelectableButton({ active, ...rest }: ButtonProps) {
  return <Button active={active} rightIcon={active ? 'tick' : undefined} {...rest} />;
}

SelectableButton.defaultProps = {
  alignText: 'left',
  p: '12px'
};

export default SelectableButton;
